import React from "react";
import "./styles.css";
import PackDetailsHeader from "./PackDetailsHeader";
import TableHeading from "./TableHeading";
import TableRow from "./TableRow";
import PackDetailsFooter from "./PackDetailsFooter";

const Details = ({hasThreePack, packHeaderDetails, packFeatures, goToNextStep }) => {
  return (
  <main className="packDetails-container">
    <PackDetailsHeader hasThreePack={hasThreePack} packHeaderDetails={packHeaderDetails} goToNextStep={goToNextStep} />

    {packFeatures.map(feature => {
      if(!feature) return null
      const { isHeading, title, text } = feature;
      if (isHeading) {
        return <TableHeading content={feature} key={text} />;
      }
      if (feature && Object.keys(feature).length) { 
        return <TableRow hasThreePack={hasThreePack} content={feature} key={title} />; 
      }
      return null
    })}
    <PackDetailsFooter hasThreePack={hasThreePack} packFooterDetails={packHeaderDetails} goToNextStep={goToNextStep} />
  </main>
);}

export default Details;



// WEBPACK FOOTER //
// ./src/components/buy/table-checkouts/PackSelectorPage/Details/index.js